import { Fragment } from "react";

export type FlowStep = {
  title: string;
  subtitle?: string;
};

type ProcessFlowProps = {
  steps: FlowStep[];
  dark?: boolean;
};

export default function ProcessFlow({ steps, dark = false }: ProcessFlowProps) {
  const titleCls = dark ? "text-white" : "text-ink";
  const subtitleCls = dark ? "text-gold-soft" : "text-ink-soft";
  const lineCls = dark ? "text-white/50" : "text-gold";

  return (
    <div className="flex flex-col lg:flex-row lg:items-stretch gap-2">
      {steps.map((step, i) => (
        <Fragment key={i}>
          <div className="flex lg:flex-col items-center gap-4 lg:gap-4 lg:flex-1 lg:text-center lg:py-2">
            <div className="w-11 h-11 shrink-0 rounded-full bg-gold text-primary-dark flex items-center justify-center text-base font-bold">
              {i + 1}
            </div>
            <div className="lg:text-center">
              <p className={`font-semibold text-base ${titleCls}`}>{step.title}</p>
              {step.subtitle && (
                <p className={`text-sm mt-1 ${subtitleCls}`}>{step.subtitle}</p>
              )}
            </div>
          </div>
          {i < steps.length - 1 && (
            <div className="flex items-center justify-center lg:flex-1 lg:py-2">
              <i
                className={`ri-arrow-down-line lg:hidden ${lineCls}`}
                aria-hidden="true"
              ></i>
              <i
                className={`ri-arrow-right-line hidden lg:block ${lineCls}`}
                aria-hidden="true"
              ></i>
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}